import {
  ChangeDetectionStrategy,
  Component,
  computed,
  HostBinding,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';

export type ReadonlyFieldColSize = '3' | '4' | '6' | '8' | '12';

let fieldIdCounter = 0;

@Component({
  selector: 'app-constitution-readonly-field',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, InputTextModule, InputTextareaModule],
  templateUrl: './constitution-readonly-field.component.html',
  styleUrls: [
    '../../../constitution-form/constitution-form.component.scss',
    './constitution-readonly-field.component.scss',
  ],
})
export class ConstitutionReadonlyFieldComponent {
  label = input.required<string>();
  value = input<string | number | null | undefined>(null);
  colSize = input<ReadonlyFieldColSize>('6');
  multiline = input(false);
  emptyPlaceholder = input('—');

  readonly fieldId = `cr-readonly-field-${++fieldIdCounter}`;

  readonly displayValue = computed(() => {
    const raw = this.value();
    if (raw === null || raw === undefined || raw === '') {
      return this.emptyPlaceholder();
    }
    return String(raw);
  });

  @HostBinding('class')
  get hostClasses(): string {
    return `column is-${this.colSize()} form-container`;
  }
}
